import { FC, PropsWithChildren, HTMLAttributes } from 'react'
import { Colors } from '../../style/colors'
import { WithClassName } from '../../types/utils'
import { cn } from '../../utils/cn'

type TableCellProps = WithClassName & {
  colspan?: number
  hideBorder?: boolean
  isFirst?: boolean
  isLast?: boolean
  isOnly?: boolean
  style?: HTMLAttributes<HTMLTableCellElement>['style']
}

export const TableCell: FC<PropsWithChildren<TableCellProps>> = ({ children, colspan = 1, className, hideBorder = false, isFirst = false, isLast = false, isOnly = false, ...props }) => {
  const style: React.CSSProperties = {
    position: 'relative',
    borderBottom: hideBorder ? 'transparent' : `1px solid ${Colors.Platinum}`,
    ...props.style,
    ...(isLast && !isOnly
      ? {
          boxShadow: `inset -1px 0 0 0 ${Colors.Platinum}`,
        }
      : {}),

    ...(isFirst && !isOnly
      ? {
          borderRadius: 0,
          boxShadow: `inset 1px 0 0 0 ${Colors.Platinum}`,
        }
      : {}),

    ...(isOnly
      ? {
          boxShadow: `inset -1px 0 0 0 ${Colors.Platinum}, inset 1px 0 0 0 ${Colors.Platinum}`,
        }
      : {}),
  }

  return (
    <td colSpan={colspan} className={cn('py-2 px-4', className)} style={style}>
      {children}
    </td>
  )
}
